import styled, { css } from 'styled-components';

const controlsVariant = {
  true: css`
    background: ${({ theme }) => theme.COLORS.NEUTRAL_5};
    border: 2px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
    border-radius: 3px;
    z-index: 25;
  `
};

const labelVariants = {
  disabled: css`
    color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
    cursor: default;
    &:hover {
      background: unset;
    }
  `
};

export const ControlsButton = styled.div`
  display: flex;
  justify-content: center;
  justify-items: center;
  position: relative;
  width: 27px;
  padding: 4px 10px;
  box-sizing: border-box;
  border: 2px solid ${({ theme }) => theme.COLORS.TRANSPARENT};
  ${props => controlsVariant[props.isOpen]}
  cursor: pointer;
  svg {
    height: 18px;
  }
}
`;

export const StyledFooterControls = styled.div`
  width: min-content;
  white-space: nowrap;
  position: absolute;
  top: -12px;
  right: -12px;
  background: ${({ theme }) => theme.COLORS.BASE};
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  padding: 12px;
  padding-right: 18px;
  cursor: pointer;
  z-index: 19;
`;

export const StyledTradeOption = styled.div`
  padding: 6px;
  min-width: 180px;
  color: ${({ theme }) => theme.COLORS.TERTIARY};
  margin-right: 28px;
  cursor: ${({ isCopy }) => (isCopy ? 'copy' : 'pointer')};
  &:hover {
    background: ${({ theme }) => theme.COLORS.NEUTRAL_5};
  }
  ${({ disabled }) => disabled && labelVariants.disabled}
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: end;
  align-items: flex-start;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
`;
